import { render, staticRenderFns } from "./PageAttribute.vue?vue&type=template&id=68c3c45c"
import script from "./PageAttribute.vue?vue&type=script&lang=js"
export * from "./PageAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports